/*
Copyright© Celligence International, LLC - 2024

This software program is protected by copyright laws and is the property of
Celligence International, LLC (Celligence). Any unauthorized reproduction,
distribution, modification, or public display of this program, without the
explicit permission of Celligence is strictly prohibited. If you have gained

access to this program without the expressed approval of Celligence report
the incident to legal@celligence.com.
*/

import Styles from '../css/ErrorPage.module.css';

const NoPageFound = () => {
  return (
    <section className={Styles.page}>
      <section className={Styles.errorContainer}>
        <h1 className={Styles.errorHeader}>You've reached a page that doesn't exist, has moved, or is under update.</h1>
        <p className={Styles.errorText}>
          <a href={process.env.REACT_APP_SWMC_CONTACT_US}>Contact us</a>
        </p>
      </section>
    </section>
  );
};

export default NoPageFound;
